import { IsEnum, Length } from 'class-validator';

import { WebsiteSliderButtonPathTypeEnum } from '@onArte/shared/enums/common/websiteSliders';

export class SliderButtonPathConfigModel {
  @IsEnum(WebsiteSliderButtonPathTypeEnum)
  public type: WebsiteSliderButtonPathTypeEnum;

  @Length(3, 1000)
  public value: string;
}
